import { useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import useNavRoutes from '@usas/ui-web/state/security/UseNavRoutes';
import useBasePersonData from '@usas/ui-web/state/personBase/UseBasePersonData';
import useSearchMemberData from '@usas/ui-web/state/searchMember/UseSearchMemberData';

const useMemberMergeSearch = () => {
  const navigate = useNavigate();
  const { navRoutes } = useNavRoutes();
  const { basePersonState } = useBasePersonData();
  const { searchMemberState } = useSearchMemberData();

  const onSelectPersonB = (e, personId) => {
    e?.preventDefault();

    const personAId = basePersonState.objData?.personId;
    const personBId = personId;

    if (personAId && personBId) {
      navigate(navRoutes.MEMBER_MERGE_SELECTION?.route, { state: { personAId, personBId } });
    }
  };

  return {
    personAId: basePersonState.objData?.personId,
    searchMemberState,
    onSelectPersonB
  };
};

export default useMemberMergeSearch;